import React from 'react';
import AnalyticsCard from '../../analytics-card/AnalyticsCard';
import './refused-cookies-card.scss';
import { withAnalyticsAppContext } from '../../../context/analytics-app-context';

function RefusedCookiesCard({ appContext }) {
    const { loading } = appContext;
    const {
        analyticsCardTitle,
        visitorsThatRejectedCookies
    } = appContext.analyticsData || {};
    return (
        <div className='analytics-grid-refused-cookies grid-item'>
            <AnalyticsCard
                isLoading={loading}
                title={'Refused Some Cookies'}
                content={`${visitorsThatRejectedCookies || 0}`}
                chipValue={analyticsCardTitle || ''}
            ></AnalyticsCard>
        </div>
    );
}

export default withAnalyticsAppContext(RefusedCookiesCard);
